/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const supplierTypeJSON = async (): Promise<any> => {
  const supplierType = useJSONStore.getState().supplierType;
  const token = useUserStore.getState().userToken;
  const setSupplierType = useJSONStore.getState().setSupplierType;

  if (supplierType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.supplierType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setSupplierType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default supplierTypeJSON;
